
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c49"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c49"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cOkcl", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function() {
        "use strict";
        var e = {
            27: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.FORM_BASE_URL = t.POPUP_SIZE = t.SLIDER_WIDTH = t.SLIDER_POSITION = t.SIDETAB_ATTRIBUTE = t.WIDGET_ATTRIBUTE = t.SLIDER_ATTRIBUTE = t.POPUP_ATTRIBUTE = t.POPOVER_ATTRIBUTE = void 0, t.POPOVER_ATTRIBUTE = "data-tf-popover", t.POPUP_ATTRIBUTE = "data-tf-popup", t.SLIDER_ATTRIBUTE = "data-tf-slider", t.WIDGET_ATTRIBUTE = "data-tf-widget", t.SIDETAB_ATTRIBUTE = "data-tf-sidetab", t.SLIDER_POSITION = "right", t.SLIDER_WIDTH = 800, t.POPUP_SIZE = 100, t.FORM_BASE_URL = "https://form.typeform.com";
            },
            528: function(e, t, n) {
                var o = this && this.__assign || function() {
                    return (o = Object.assign || function(e) {
                        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                    }).apply(this, arguments);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createPopover = void 0;
                var r = n(747), i = n(320), a = function(e, t) {
                    var n = e.parentNode;
                    n && (n.removeChild(e), n.appendChild(t));
                }, u = function(e, t) {
                    void 0 === e && (e = "div"), void 0 === t && (t = "tf-v1-popover-button-icon");
                    var n = document.createElement(e);
                    return n.className = t + " tf-v1-close-icon", n.innerHTML = "&times;", n.dataset.testid = t, n;
                }, s = {
                    buttonColor: "#3a7685"
                };
                t.createPopover = function(e, t) {
                    void 0 === t && (t = {});
                    var n, c, d, l = o(o({}, s), t), f = r.createIframe(e, "popover", l), p = f.iframe, v = f.embedId, m = f.refresh, h = f.focus, b = function(e, t) {
                        var n = document.createElement("div");
                        return n.className = "tf-v1-popover", n.dataset.testid = "tf-v1-popover", r.setElementSize(n, {
                            width: e,
                            height: t
                        });
                    }(l.width, l.height), y = function() {
                        var e = document.createElement("div");
                        return e.className = "tf-v1-popover-wrapper", e.dataset.testid = "tf-v1-popover-wrapper", e;
                    }(), g = function(e, t) {
                        var n = r.getTextColor(t), o = document.createElement("div");
                        o.className = "tf-v1-popover-button-icon";
                        var i = '<svg class="default" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M21 0H0V9L10.5743 24V16.5H21C22.6567 16.5 24 15.1567 24 13.5V3C24 1.34325 22.6567 0 21 0ZM7.5\n    9.75C6.672 9.75 6 9.07875 6 8.25C6 7.42125 6.672 6.75 7.5 6.75C8.328 6.75 9 7.42125 9 8.25C9 9.07875 8.328 9.75\n    7.5 9.75ZM12.75 9.75C11.922 9.75 11.25 9.07875 11.25 8.25C11.25 7.42125 11.922 6.75 12.75 6.75C13.578 6.75 14.25\n    7.42125 14.25 8.25C14.25 9.07875 13.578 9.75 12.75 9.75ZM18 9.75C17.172 9.75 16.5 9.07875 16.5 8.25C16.5 7.42125\n    17.172 6.75 18 6.75C18.828 6.75 19.5 7.42125 19.5 8.25C19.5 9.07875 18.828 9.75 18 9.75Z" fill="' + n + '"></path>\n  </svg>', a = null == e ? void 0 : e.startsWith("http");
                        return o.innerHTML = a ? "<img alt='popover trigger icon button' src='" + e + "'/>" : null != e ? e : i, o.dataset.testid = "default-icon", o;
                    }(l.customIcon, l.buttonColor || s.buttonColor), w = function() {
                        var e = document.createElement("div");
                        e.className = "tf-v1-spinner";
                        var t = document.createElement("div");
                        return t.className = "tf-v1-popover-button-icon", t.dataset.testid = "spinner-icon", t.append(e), t;
                    }(), O = u(), _ = u("a", "tf-v1-popover-close"), E = function(e) {
                        var t = r.getTextColor(e), n = document.createElement("button");
                        return n.className = "tf-v1-popover-button", n.dataset.testid = "tf-v1-popover-button", n.style.backgroundColor = e, n.style.color = t, n;
                    }(l.buttonColor || s.buttonColor);
                    (l.container || document.body).append(b), y.append(p), b.append(E), b.append(_), E.append(g);
                    var P = function() {
                        c && c.parentNode && (c.classList.add("closing"), setTimeout(function() {
                            r.unmountElement(c);
                        }, 250));
                    };
                    l.tooltip && l.tooltip.length > 0 && (c = function(e, t) {
                        var n = document.createElement("span");
                        n.className = "tf-v1-popover-tooltip-close", n.dataset.testid = "tf-v1-popover-tooltip-close", n.innerHTML = "&times;", n.onclick = t;
                        var o = document.createElement("div");
                        o.className = "tf-v1-popover-tooltip-text", o.innerHTML = e;
                        var r = document.createElement("div");
                        return r.className = "tf-v1-popover-tooltip", r.dataset.testid = "tf-v1-popover-tooltip", r.appendChild(o), r.appendChild(n), r;
                    }(l.tooltip, P), b.append(c)), l.notificationDays && (l.enableSandbox || i.canBuildNotificationDot(e)) && (d = i.buildNotificationDot(), E.append(d)), p.onload = function() {
                        b.classList.add("open"), y.style.opacity = "1", _.style.opacity = "1", a(w, O), r.addCustomKeyboardListener(I);
                    };
                    var C = r.makeAutoResize(b), j = function() {
                        r.isOpen(y) || (P(), d && (d.classList.add("closing"), l.notificationDays && !l.enableSandbox && i.saveNotificationDotHideUntilTime(e, l.notificationDays), setTimeout(function() {
                            r.unmountElement(d);
                        }, 250)), C(), window.addEventListener("resize", C), setTimeout(function() {
                            r.isInPage(y) ? (y.style.opacity = "0", _.style.opacity = "0", y.style.display = "flex", setTimeout(function() {
                                b.classList.add("open"), y.style.opacity = "1", _.style.opacity = "1";
                            }), a(g, O)) : (b.append(y), a(g, w), y.style.opacity = "0", _.style.opacity = "0");
                        }));
                    }, I = function() {
                        var e;
                        r.isOpen(b) && (null === (e = t.onClose) || void 0 === e || e.call(t), setTimeout(function() {
                            l.keepSession ? y.style.display = "none" : r.unmountElement(y), b.classList.remove("open"), a(O, g);
                        }, 250));
                    };
                    r.setAutoClose(v, l.autoClose, I);
                    var T = function() {
                        r.isOpen(y) ? I() : j();
                    };
                    return E.onclick = T, _.onclick = I, l.open && !r.isOpen(y) && (n = r.handleCustomOpen(j, l.open, l.openValue)), {
                        open: j,
                        close: I,
                        toggle: T,
                        refresh: m,
                        focus: h,
                        unmount: function() {
                            r.unmountElement(b), window.removeEventListener("resize", C), l.open && (null == n ? void 0 : n.remove) && n.remove();
                        }
                    };
                };
            },
            797: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n), Object.defineProperty(e, o, {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    });
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(528), t), r(n(100), t);
            },
            320: function(e, t) {
                var n = this && this.__assign || function() {
                    return (n = Object.assign || function(e) {
                        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                    }).apply(this, arguments);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.buildNotificationDot = t.canBuildNotificationDot = t.saveNotificationDotHideUntilTime = void 0;
                var o = "tfNotificationData", r = function() {
                    var e = localStorage.getItem(o);
                    return e ? JSON.parse(e) : {};
                }, i = function(e) {
                    e && localStorage.setItem(o, JSON.stringify(e));
                };
                t.saveNotificationDotHideUntilTime = function(e, t) {
                    var o, a = new Date;
                    a.setDate(a.getDate() + t), i(n(n({}, r()), ((o = {})[e] = {
                        hideUntilTime: a.getTime()
                    }, o)));
                }, t.canBuildNotificationDot = function(e) {
                    var t = function(e) {
                        var t;
                        return (null === (t = r()[e]) || void 0 === t ? void 0 : t.hideUntilTime) || 0;
                    }(e);
                    return (new Date).getTime() > t && (t && function(e) {
                        var t = r();
                        delete t[e], i(t);
                    }(e), !0);
                }, t.buildNotificationDot = function() {
                    var e = document.createElement("span");
                    return e.className = "tf-v1-popover-unread-dot", e.dataset.testid = "tf-v1-popover-unread-dot", e;
                };
            },
            100: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            630: function(e, t, n) {
                var o = this && this.__rest || function(e, t) {
                    var n = {};
                    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var r = 0;
                        for(o = Object.getOwnPropertySymbols(e); r < o.length; r++)t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
                    }
                    return n;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createPopup = void 0;
                var r = n(747), i = n(27), a = n(747);
                t.createPopup = function(e, t) {
                    if (void 0 === t && (t = {}), !r.hasDom()) return {
                        open: function() {},
                        close: function() {},
                        toggle: function() {},
                        refresh: function() {},
                        focus: function() {},
                        unmount: function() {}
                    };
                    var n, u = t.width, s = t.height, c = t.size, d = void 0 === c ? i.POPUP_SIZE : c, l = t.onClose, f = o(t, [
                        "width",
                        "height",
                        "size",
                        "onClose"
                    ]), p = r.createIframe(e, "popup", f), v = p.iframe, m = p.embedId, h = p.refresh, b = p.focus, y = document.body.style.overflow, g = function() {
                        var e = document.createElement("div");
                        return e.className = "tf-v1-popup", e.dataset.testid = "tf-v1-popup", e.style.opacity = "0", e;
                    }(), w = function() {
                        var e = document.createElement("div");
                        return e.className = "tf-v1-spinner", e;
                    }(), O = function(e, t, n) {
                        var o = document.createElement("div");
                        return o.className = "tf-v1-iframe-wrapper", o.style.opacity = "0", r.isDefined(e) && r.isDefined(t) ? r.setElementSize(o, {
                            width: e,
                            height: t
                        }) : (o.style.width = "calc(" + n + "% - 80px)", o.style.height = "calc(" + n + "% - 80px)", o);
                    }(u, s, d);
                    O.append(v), g.append(w), g.append(O);
                    var _ = f.container || document.body;
                    v.onload = function() {
                        O.style.opacity = "1", setTimeout(function() {
                            w.style.display = "none";
                        }, 250), r.addCustomKeyboardListener(C);
                    };
                    var E = a.makeAutoResize(g), P = function() {
                        a.isOpen(g) || (a.isInPage(g) ? g.style.display = "flex" : (w.style.display = "block", _.append(g)), document.body.style.overflow = "hidden", E(), window.addEventListener("resize", E), setTimeout(function() {
                            g.style.opacity = "1";
                        }));
                    }, C = function() {
                        a.isOpen(g) && (null == l || l(), g.style.opacity = "0", document.body.style.overflow = y, setTimeout(function() {
                            f.keepSession ? g.style.display = "none" : j();
                        }, 250));
                    };
                    O.append(function(e) {
                        var t = document.createElement("a");
                        return t.className = "tf-v1-close tf-v1-close-icon", t.innerHTML = "&times;", t.onclick = e, t;
                    }(C)), r.setAutoClose(m, f.autoClose, C), f.open && !a.isOpen(g) && (n = r.handleCustomOpen(P, f.open, f.openValue));
                    var j = function() {
                        r.unmountElement(g), window.removeEventListener("resize", E), f.open && (null == n ? void 0 : n.remove) && n.remove();
                    };
                    return {
                        open: P,
                        close: C,
                        toggle: function() {
                            a.isOpen(g) ? C() : P();
                        },
                        refresh: h,
                        focus: b,
                        unmount: j
                    };
                };
            },
            970: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n), Object.defineProperty(e, o, {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    });
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(630), t), r(n(394), t);
            },
            394: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            382: function(e, t, n) {
                var o = this && this.__assign || function() {
                    return (o = Object.assign || function(e) {
                        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                    }).apply(this, arguments);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createSidetab = void 0;
                var r = n(747), i = {
                    buttonColor: "#3a7685",
                    buttonText: "Launch me"
                }, a = function(e, t) {
                    void 0 === e && (e = "div"), void 0 === t && (t = "tf-v1-sidetab-button-icon");
                    var n = document.createElement(e);
                    return n.className = t + " tf-v1-close-icon", n.innerHTML = "&times;", n.dataset.testid = t, n;
                }, u = function(e, t) {
                    var n = e.parentNode;
                    n && (n.removeChild(e), n.appendChild(t));
                };
                t.createSidetab = function(e, t) {
                    void 0 === t && (t = {});
                    var n, s = o(o({}, i), t), c = r.createIframe(e, "side-tab", s), d = c.iframe, l = c.embedId, f = c.refresh, p = c.focus, v = function(e, t) {
                        var n = document.createElement("div");
                        return n.className = "tf-v1-sidetab", n.dataset.testid = "tf-v1-sidetab", r.setElementSize(n, {
                            width: e,
                            height: t
                        });
                    }(s.width, s.height), m = function() {
                        var e = document.createElement("div");
                        return e.className = "tf-v1-sidetab-wrapper", e.dataset.testid = "tf-v1-sidetab-wrapper", e;
                    }(), h = function() {
                        var e = document.createElement("div");
                        e.className = "tf-v1-spinner";
                        var t = document.createElement("div");
                        return t.className = "tf-v1-sidetab-button-icon", t.dataset.testid = "spinner-icon", t.append(e), t;
                    }(), b = function(e) {
                        var t = r.getTextColor(e), n = document.createElement("button");
                        return n.className = "tf-v1-sidetab-button", n.style.backgroundColor = e, n.style.color = t, n;
                    }(s.buttonColor || i.buttonColor), y = function(e) {
                        var t = document.createElement("span");
                        return t.className = "tf-v1-sidetab-button-text", t.innerHTML = e, t;
                    }(s.buttonText || i.buttonText), g = function(e, t) {
                        var n = r.getTextColor(t), o = document.createElement("div");
                        o.className = "tf-v1-sidetab-button-icon";
                        var i = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M21 0H0V9L10.5743 24V16.5H21C22.6567 16.5 24 15.1567 24 13.5V3C24 1.34325 22.6567 0 21 0ZM7.5 9.75C6.672 9.75 6 9.07875 6 8.25C6 7.42125 6.672 6.75 7.5 6.75C8.328 6.75 9 7.42125 9 8.25C9 9.07875 8.328 9.75 7.5 9.75ZM12.75 9.75C11.922 9.75 11.25 9.07875 11.25 8.25C11.25 7.42125 11.922 6.75 12.75 6.75C13.578 6.75 14.25 7.42125 14.25 8.25C14.25 9.07875 13.578 9.75 12.75 9.75ZM18 9.75C17.172 9.75 16.5 9.07875 16.5 8.25C16.5 7.42125 17.172 6.75 18 6.75C18.828 6.75 19.5 7.42125 19.5 8.25C19.5 9.07875 18.828 9.75 18 9.75Z" fill="' + n + '"></path>\n  </svg>', a = null == e ? void 0 : e.startsWith("http");
                        return o.innerHTML = a ? "<img alt='popover trigger icon button' src='" + e + "'/>" : null != e ? e : i, o.dataset.testid = "default-icon", o;
                    }(s.customIcon, s.buttonColor || i.buttonColor), w = a(), O = a("a", "tf-v1-sidetab-close");
                    (s.container || document.body).append(v), m.append(d), v.append(b), v.append(O), b.append(g), b.append(y), setTimeout(function() {
                        v.classList.add("ready");
                    }, 250), d.onload = function() {
                        v.classList.add("open"), u(h, w), r.addCustomKeyboardListener(P);
                    };
                    var _ = r.makeAutoResize(v), E = function() {
                        r.isOpen(m) || (_(), window.addEventListener("resize", _), r.isInPage(m) ? (m.style.display = "flex", v.classList.add("open"), u(g, w)) : (v.append(m), u(g, h)));
                    }, P = function() {
                        var e;
                        r.isOpen(m) && (null === (e = s.onClose) || void 0 === e || e.call(s), v.classList.remove("open"), setTimeout(function() {
                            s.keepSession ? m.style.display = "none" : r.unmountElement(m), u(w, g);
                        }, 250));
                    };
                    r.setAutoClose(l, s.autoClose, P);
                    var C = function() {
                        r.isOpen(m) ? P() : E();
                    };
                    return b.onclick = C, O.onclick = P, s.open && !r.isOpen(m) && (n = r.handleCustomOpen(E, s.open, s.openValue)), {
                        open: E,
                        close: P,
                        toggle: C,
                        refresh: f,
                        focus: p,
                        unmount: function() {
                            r.unmountElement(v), window.removeEventListener("resize", _), s.open && (null == n ? void 0 : n.remove) && n.remove();
                        }
                    };
                };
            },
            434: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n), Object.defineProperty(e, o, {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    });
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(382), t), r(n(668), t);
            },
            668: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            603: function(e, t, n) {
                var o = this && this.__rest || function(e, t) {
                    var n = {};
                    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var r = 0;
                        for(o = Object.getOwnPropertySymbols(e); r < o.length; r++)t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
                    }
                    return n;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createSlider = void 0;
                var r = n(747), i = n(27);
                t.createSlider = function(e, t) {
                    if (void 0 === t && (t = {}), !r.hasDom()) return {
                        open: function() {},
                        close: function() {},
                        toggle: function() {},
                        refresh: function() {},
                        focus: function() {},
                        unmount: function() {}
                    };
                    var n, a = t.position, u = void 0 === a ? i.SLIDER_POSITION : a, s = t.width, c = void 0 === s ? i.SLIDER_WIDTH : s, d = t.onClose, l = o(t, [
                        "position",
                        "width",
                        "onClose"
                    ]), f = r.createIframe(e, "slider", l), p = f.iframe, v = f.embedId, m = f.refresh, h = f.focus, b = document.body.style.overflow, y = function(e) {
                        var t = document.createElement("div");
                        return t.className = "tf-v1-slider " + e, t.dataset.testid = "tf-v1-slider", t.style.opacity = "0", t;
                    }(u), g = function() {
                        var e = document.createElement("div");
                        return e.className = "tf-v1-spinner", e;
                    }(), w = function(e, t) {
                        var n = document.createElement("div");
                        return n.className = "tf-v1-iframe-wrapper", n.style[e] = "-100%", r.setElementSize(n, {
                            width: t
                        });
                    }(u, c);
                    w.append(p), y.append(g), y.append(w);
                    var O = l.container || document.body;
                    p.onload = function() {
                        w.style[u] = "0", setTimeout(function() {
                            g.style.display = "none";
                        }, 500), r.addCustomKeyboardListener(P);
                    };
                    var _ = r.makeAutoResize(y), E = function() {
                        r.isOpen(y) || (_(), window.addEventListener("resize", _), r.isInPage(y) ? (y.style.display = "flex", setTimeout(function() {
                            w.style[u] = "0";
                        })) : (O.append(y), g.style.display = "block"), document.body.style.overflow = "hidden", setTimeout(function() {
                            y.style.opacity = "1";
                        }));
                    }, P = function() {
                        r.isOpen(y) && (null == d || d(), y.style.opacity = "0", w.style[u] = "-100%", document.body.style.overflow = b, setTimeout(function() {
                            l.keepSession ? y.style.display = "none" : C();
                        }, 500));
                    };
                    r.setAutoClose(v, l.autoClose, P), w.append(function(e) {
                        var t = document.createElement("a");
                        return t.className = "tf-v1-close tf-v1-close-icon", t.innerHTML = "&times;", t.onclick = e, t;
                    }(P)), l.open && !r.isOpen(y) && (n = r.handleCustomOpen(E, l.open, l.openValue));
                    var C = function() {
                        r.unmountElement(y), window.removeEventListener("resize", _), l.open && (null == n ? void 0 : n.remove) && n.remove();
                    };
                    return {
                        open: E,
                        close: P,
                        toggle: function() {
                            r.isOpen(y) ? P() : E();
                        },
                        refresh: m,
                        focus: h,
                        unmount: C
                    };
                };
            },
            331: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n), Object.defineProperty(e, o, {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    });
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(603), t), r(n(162), t);
            },
            162: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            718: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createWidget = void 0;
                var o = n(747), r = n(554), i = n(313);
                t.createWidget = function(e, t) {
                    if (!o.hasDom()) return {
                        refresh: function() {},
                        focus: function() {},
                        unmount: function() {}
                    };
                    var n = t;
                    t.inlineOnMobile || !t.forceTouch && !o.isFullscreen() || (n.enableFullscreen = !0, n.forceTouch = !0);
                    var a = o.createIframe(e, "widget", n), u = a.embedId, s = a.iframe, c = a.refresh, d = a.focus, l = i.buildWidget(s, t.width, t.height);
                    if (n.autoResize) {
                        var f = "string" == typeof n.autoResize ? n.autoResize.split(",").map(function(e) {
                            return parseInt(e);
                        }) : [], p = f[0], v = f[1];
                        window.addEventListener("message", r.getFormHeightChangedHandler(u, function(e) {
                            var n = Math.max(e.height, p || 0);
                            v && (n = Math.min(n, v)), t.container.style.height = n + "px";
                        }));
                    }
                    n.autoFocus && window.addEventListener("message", r.getFormReadyHandler(u, function() {
                        setTimeout(function() {
                            d();
                        }, 1e3);
                    }));
                    var m, h = function() {
                        return t.container.append(l);
                    };
                    if (t.container.innerHTML = "", t.lazy ? o.lazyInitialize(t.container, h) : h(), n.enableFullscreen) {
                        var b = "", y = t.container, g = o.makeAutoResize(y), w = y.style.height;
                        window.addEventListener("message", r.getWelcomeScreenHiddenHandler(u, function() {
                            y.classList.add("tf-v1-widget-fullscreen"), void 0 !== t.opacity && (y.style.backgroundColor = b), g(), window.addEventListener("resize", g);
                        })), window.addEventListener("message", r.getFormThemeHandler(u, function(e) {
                            var t;
                            b = o.changeColorOpacity(null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.backgroundColor);
                        }));
                        var O = ((m = document.createElement("a")).className = "tf-v1-widget-close tf-v1-close-icon", m.innerHTML = "&times;", m);
                        O.onclick = function() {
                            var e;
                            if (window.removeEventListener("resize", g), y.style.height = w, null === (e = t.onClose) || void 0 === e || e.call(t), y.classList.remove("tf-v1-widget-fullscreen"), y.style.backgroundColor = "", t.keepSession) {
                                var n = document.createElement("div");
                                n.className = "tf-v1-widget-iframe-overlay", n.onclick = function() {
                                    y.classList.add("tf-v1-widget-fullscreen"), o.unmountElement(n);
                                }, l.append(n);
                            } else t.container.innerHTML = "", h(), y.append(O);
                        }, y.append(O);
                    }
                    return {
                        refresh: c,
                        focus: d,
                        unmount: function() {
                            return o.unmountElement(l);
                        }
                    };
                };
            },
            419: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.buildWidget = void 0;
                var o = n(747);
                t.buildWidget = function(e, t, n) {
                    var r = document.createElement("div");
                    return r.className = "tf-v1-widget", r.dataset.testid = "tf-v1-widget", r.append(e), o.setElementSize(r, {
                        width: t,
                        height: n
                    });
                };
            },
            313: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n), Object.defineProperty(e, o, {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    });
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(419), t);
            },
            321: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n), Object.defineProperty(e, o, {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    });
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(718), t), r(n(58), t);
            },
            58: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            920: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n), Object.defineProperty(e, o, {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    });
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(797), t), r(n(970), t), r(n(331), t), r(n(321), t), r(n(434), t);
            },
            626: function(e, t, n) {
                var o = this && this.__assign || function() {
                    return (o = Object.assign || function(e) {
                        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                    }).apply(this, arguments);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.buildIframeSrc = void 0;
                var r = n(27), i = n(527), a = n(346), u = n(698), s = n(863), c = {
                    widget: "embed-widget",
                    popup: "popup-blank",
                    slider: "popup-drawer",
                    popover: "popup-popover",
                    "side-tab": "popup-side-panel"
                };
                t.buildIframeSrc = function(e) {
                    var t = e.formId, n = e.type, d = e.embedId, l = e.options, f = function(e, t, n) {
                        var r = n.transitiveSearchParams, i = n.source, a = n.medium, s = n.mediumVersion, d = n.hideFooter, l = n.hideHeaders, f = n.opacity, p = n.disableTracking, v = n.enableSandbox, m = n.shareGaInstance, h = n.forceTouch, b = n.enableFullscreen, y = n.tracking, g = n.redirectTarget, w = n.autoResize, O = u.getTransitiveSearchParams(r);
                        return o(o(o({}, {
                            "typeform-embed-id": t,
                            "typeform-embed": c[e],
                            "typeform-source": i,
                            "typeform-medium": a,
                            "typeform-medium-version": s,
                            "embed-hide-footer": d ? "true" : void 0,
                            "embed-hide-headers": l ? "true" : void 0,
                            "embed-opacity": f,
                            "disable-tracking": p || v ? "true" : void 0,
                            "__dangerous-disable-submissions": v ? "true" : void 0,
                            "share-ga-instance": m ? "true" : void 0,
                            "force-touch": h ? "true" : void 0,
                            "add-placeholder-ws": "widget" === e && b ? "true" : void 0,
                            "typeform-embed-redirect-target": g,
                            "typeform-embed-auto-resize": w ? "true" : void 0
                        }), O), y);
                    }(n, d, function(e) {
                        var t;
                        return o(o({}, {
                            source: null === (t = null === window || void 0 === window ? void 0 : window.location) || void 0 === t ? void 0 : t.hostname.replace(/^www\./, ""),
                            medium: "embed-sdk",
                            mediumVersion: "next"
                        }), i.removeUndefinedKeys(e));
                    }(l)), p = function(e, t) {
                        void 0 === t && (t = !1);
                        var n = t ? "c" : "to";
                        return new URL(e.startsWith("http://") || e.startsWith("https://") ? e : r.FORM_BASE_URL + "/" + n + "/" + e);
                    }(t, l.chat);
                    if (Object.entries(f).filter(function(e) {
                        var t = e[1];
                        return a.isDefined(t);
                    }).forEach(function(e) {
                        var t = e[0], n = e[1];
                        p.searchParams.set(t, n);
                    }), l.hubspot) {
                        var v = s.getHubspotHiddenFields();
                        l.hidden = o(o({}, l.hidden), v);
                    }
                    if (l.hidden) {
                        var m = new URL(r.FORM_BASE_URL);
                        Object.entries(l.hidden).filter(function(e) {
                            var t = e[1];
                            return a.isDefined(t);
                        }).forEach(function(e) {
                            var t = e[0], n = e[1];
                            m.searchParams.set(t, n);
                        });
                        var h = m.searchParams.toString();
                        h && (p.hash = h);
                    }
                    return p.href;
                };
            },
            391: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.changeColorOpacity = void 0, t.changeColorOpacity = function(e, t) {
                    return void 0 === e && (e = ""), void 0 === t && (t = 255), e.startsWith("rgba(") ? null == e ? void 0 : e.replace(/, [\d.]+\)$/, ", " + t + ")") : e;
                };
            },
            972: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.handleCustomOpen = void 0;
                var n = {
                    remove: function() {}
                };
                t.handleCustomOpen = function(e, t, o) {
                    switch(t){
                        case "load":
                            return e(), n;
                        case "exit":
                            return o ? function(e, t) {
                                var n = 0, o = function(r) {
                                    r.clientY < e && r.clientY < n ? (document.removeEventListener("mousemove", o, !0), t()) : n = r.clientY;
                                };
                                return document.addEventListener("mousemove", o, !0), {
                                    remove: function() {
                                        return document.removeEventListener("mousemove", o, !0);
                                    }
                                };
                            }(o, e) : n;
                        case "time":
                            return setTimeout(function() {
                                e();
                            }, o), n;
                        case "scroll":
                            return o ? function(e, t) {
                                function n() {
                                    var o = window.pageYOffset || document.documentElement.scrollTop, r = document.documentElement.clientTop || 0, i = document.documentElement.scrollHeight, a = o - r, u = a / i * 100, s = a + window.innerHeight >= i;
                                    (u >= e || s) && (t(), document.removeEventListener("scroll", n));
                                }
                                return document.addEventListener("scroll", n), {
                                    remove: function() {
                                        return document.removeEventListener("scroll", n);
                                    }
                                };
                            }(o, e) : n;
                        default:
                            return n;
                    }
                };
            },
            553: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createIframe = void 0;
                var o = n(626), r = n(747), i = n(866), a = n(554), u = n(256), s = n(144), c = n(511);
                t.createIframe = function(e, t, n) {
                    var d = i.generateEmbedId(), l = n.iframeProps, f = void 0 === l ? {} : l, p = n.onReady, v = n.onQuestionChanged, m = n.onHeightChanged, h = n.onSubmit, b = n.onEndingButtonClick, y = n.shareGaInstance, g = o.buildIframeSrc({
                        formId: e,
                        embedId: d,
                        type: t,
                        options: n
                    }), w = document.createElement("iframe");
                    return w.src = g, w.dataset.testid = "iframe", w.style.border = "0px", w.allow = "microphone; camera", Object.keys(f).forEach(function(e) {
                        w.setAttribute(e, f[e]);
                    }), w.addEventListener("load", u.triggerIframeRedraw, {
                        once: !0
                    }), window.addEventListener("message", a.getFormReadyHandler(d, p)), window.addEventListener("message", a.getFormQuestionChangedHandler(d, v)), window.addEventListener("message", a.getFormHeightChangedHandler(d, m)), window.addEventListener("message", a.getFormSubmitHandler(d, h)), window.addEventListener("message", a.getFormThemeHandler(d, function(e) {
                        var t;
                        if (null == e ? void 0 : e.theme) {
                            var n = document.querySelector(".tf-v1-close-icon");
                            n && (n.style.color = null === (t = e.theme) || void 0 === t ? void 0 : t.color);
                        }
                    })), window.addEventListener("message", a.getThankYouScreenButtonClickHandler(d, b)), "widget" !== t && window.addEventListener("message", s.dispatchCustomKeyEventFromIframe), y && window.addEventListener("message", a.getFormReadyHandler(d, function() {
                        r.setupGaInstance(w, d, y);
                    })), {
                        iframe: w,
                        embedId: d,
                        refresh: function() {
                            return c.refreshIframe(w);
                        },
                        focus: function() {
                            var e;
                            null === (e = w.contentWindow) || void 0 === e || e.postMessage("embed-focus", "*");
                        }
                    };
                };
            },
            866: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.generateEmbedId = void 0, t.generateEmbedId = function() {
                    var e = Math.random();
                    return String(e).split(".")[1];
                };
            },
            554: function(e, t) {
                var n = this && this.__rest || function(e, t) {
                    var n = {};
                    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var r = 0;
                        for(o = Object.getOwnPropertySymbols(e); r < o.length; r++)t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
                    }
                    return n;
                };
                function o(e, t, o) {
                    return function(r) {
                        var i = r.data, a = i.type, u = i.embedId, s = n(i, [
                            "type",
                            "embedId"
                        ]);
                        a === e && u === t && (null == o || o(s));
                    };
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getThankYouScreenButtonClickHandler = t.getFormThemeHandler = t.getWelcomeScreenHiddenHandler = t.getFormSubmitHandler = t.getFormHeightChangedHandler = t.getFormQuestionChangedHandler = t.getFormReadyHandler = void 0, t.getFormReadyHandler = function(e, t) {
                    return o("form-ready", e, t);
                }, t.getFormQuestionChangedHandler = function(e, t) {
                    return o("form-screen-changed", e, t);
                }, t.getFormHeightChangedHandler = function(e, t) {
                    return o("form-height-changed", e, t);
                }, t.getFormSubmitHandler = function(e, t) {
                    return o("form-submit", e, t);
                }, t.getWelcomeScreenHiddenHandler = function(e, t) {
                    return o("welcome-screen-hidden", e, t);
                }, t.getFormThemeHandler = function(e, t) {
                    return o("form-theme", e, t);
                }, t.getThankYouScreenButtonClickHandler = function(e, t) {
                    return o("thank-you-screen-button-click", e, t);
                };
            },
            339: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n), Object.defineProperty(e, o, {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    });
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(553), t), r(n(144), t);
            },
            511: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.refreshIframe = void 0, t.refreshIframe = function(e) {
                    if (e) {
                        var t = e.src;
                        if (t.includes("&refresh")) {
                            var n = t.split("&refresh#");
                            e.src = n.join("#");
                        } else (n = t.split("#"))[0] = n[0] + "&refresh", e.src = n.join("#");
                    }
                };
            },
            144: function(e, t) {
                var n = this && this.__awaiter || function(e, t, n, o) {
                    return new (n || (n = Promise))(function(r, i) {
                        function a(e) {
                            try {
                                s(o.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function u(e) {
                            try {
                                s(o.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function s(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(a, u);
                        }
                        s((o = o.apply(e, t || [])).next());
                    });
                }, o = this && this.__generator || function(e, t) {
                    var n, o, r, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & r[0]) throw r[1];
                            return r[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: u(0),
                        throw: u(1),
                        return: u(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function u(i) {
                        return function(u) {
                            return function(i) {
                                if (n) throw new TypeError("Generator is already executing.");
                                for(; a;)try {
                                    if (n = 1, o && (r = 2 & i[0] ? o.return : i[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, i[1])).done) return r;
                                    switch(o = 0, r && (i = [
                                        2 & i[0],
                                        r.value
                                    ]), i[0]){
                                        case 0:
                                        case 1:
                                            r = i;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: i[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, o = i[1], i = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            i = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                                a.label = i[1];
                                                break;
                                            }
                                            if (6 === i[0] && a.label < r[1]) {
                                                a.label = r[1], r = i;
                                                break;
                                            }
                                            if (r && a.label < r[2]) {
                                                a.label = r[2], a.ops.push(i);
                                                break;
                                            }
                                            r[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    i = t.call(e, a);
                                } catch (e) {
                                    i = [
                                        6,
                                        e
                                    ], o = 0;
                                } finally{
                                    n = r = 0;
                                }
                                if (5 & i[0]) throw i[1];
                                return {
                                    value: i[0] ? i[1] : void 0,
                                    done: !0
                                };
                            }([
                                i,
                                u
                            ]);
                        };
                    }
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.dispatchCustomKeyEventFromIframe = t.removeCustomKeyboardListener = t.addCustomKeyboardListener = void 0;
                var r = "Escape", i = function(e, i) {
                    return n(void 0, void 0, void 0, function() {
                        return o(this, function(n) {
                            return e.code === r && "function" == typeof i && (i(), t.removeCustomKeyboardListener()), [
                                2
                            ];
                        });
                    });
                };
                t.addCustomKeyboardListener = function(e) {
                    return window.document.addEventListener("keydown", function(t) {
                        return i(t, e);
                    });
                }, t.removeCustomKeyboardListener = function() {
                    return window.document.removeEventListener("keydown", i);
                }, t.dispatchCustomKeyEventFromIframe = function(e) {
                    "form-close" === e.data.type && window.document.dispatchEvent(new KeyboardEvent("keydown", {
                        code: r
                    }));
                };
            },
            256: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.triggerIframeRedraw = void 0, t.triggerIframeRedraw = function() {
                    this.style.transform = "translateZ(0)";
                };
            },
            939: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getTextColor = void 0;
                var o = n(938);
                t.getTextColor = function(e) {
                    if (!e) return "#FFFFFF";
                    var t = e.startsWith("#") ? o.hexRgb(e) : function(e) {
                        var t = {
                            red: 0,
                            green: 0,
                            blue: 0
                        }, n = e.match(/\d+/g);
                        return n && (t.red = parseInt(n[0], 10), t.green = parseInt(n[0], 10), t.blue = parseInt(n[0], 10)), t;
                    }(e), n = t.red, r = t.green, i = t.blue;
                    return Math.round((299 * n + 587 * r + 114 * i) / 1e3) > 125 ? "#000000" : "#FFFFFF";
                };
            },
            698: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getTransitiveSearchParams = void 0, t.getTransitiveSearchParams = function(e) {
                    var t = new URL(window.location.href), n = {};
                    return e && e.length > 0 && e.forEach(function(e) {
                        t.searchParams.has(e) && (n[e] = t.searchParams.get(e));
                    }), n;
                };
            },
            252: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hasDom = void 0, t.hasDom = function() {
                    return "undefined" != typeof document && "undefined" != typeof window;
                };
            },
            938: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hexRgb = void 0;
                var n = new RegExp("[^#a-f\\d]", "gi"), o = new RegExp("^#?[a-f\\d]{3}[a-f\\d]?$|^#?[a-f\\d]{6}([a-f\\d]{2})?$", "i");
                t.hexRgb = function(e) {
                    if ("string" != typeof e || n.test(e) || !o.test(e)) throw new TypeError("Expected a valid hex string");
                    8 === (e = e.replace(/^#/, "")).length && (e = e.slice(0, 6)), 4 === e.length && (e = e.slice(0, 3)), 3 === e.length && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]);
                    var t = Number.parseInt(e, 16);
                    return {
                        red: t >> 16,
                        green: t >> 8 & 255,
                        blue: 255 & t
                    };
                };
            },
            863: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getHubspotHiddenFields = t.getHubspotCookieValue = void 0, t.getHubspotCookieValue = function() {
                    var e = document.cookie.match(new RegExp("(^| )hubspotutk=([^;]+)"));
                    return e && e[2] || void 0;
                }, t.getHubspotHiddenFields = function() {
                    return {
                        hubspot_page_name: document.title,
                        hubspot_page_url: window.location.href,
                        hubspot_utk: t.getHubspotCookieValue()
                    };
                };
            },
            71: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.includeCss = void 0, t.includeCss = function(e) {
                    var t = function(e) {
                        return "https://embed.typeform.com/next/css/" + e;
                    }(e);
                    if (!document.querySelector('link[href="' + t + '"]')) {
                        var n = document.createElement("link");
                        n.rel = "stylesheet", n.href = t, document.head.append(n);
                    }
                };
            },
            747: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n), Object.defineProperty(e, o, {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    });
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(626), t), r(n(339), t), r(n(252), t), r(n(71), t), r(n(346), t), r(n(377), t), r(n(563), t), r(n(527), t), r(n(533), t), r(n(451), t), r(n(972), t), r(n(748), t), r(n(392), t), r(n(939), t), r(n(917), t), r(n(987), t), r(n(318), t), r(n(391), t);
            },
            346: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isDefined = void 0, t.isDefined = function(e) {
                    return null != e;
                };
            },
            987: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isVisible = t.isInPage = t.isOpen = void 0, t.isOpen = function(e) {
                    return t.isInPage(e) && t.isVisible(e);
                }, t.isInPage = function(e) {
                    return !!e.parentNode;
                }, t.isVisible = function(e) {
                    return "none" !== e.style.display;
                };
            },
            917: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.lazyInitialize = void 0, t.lazyInitialize = function(e, t) {
                    var n = new IntersectionObserver(function(e) {
                        e.forEach(function(e) {
                            e.isIntersecting && (t(), n.unobserve(e.target));
                        });
                    });
                    n.observe(e);
                };
            },
            377: function(e, t) {
                var n = this && this.__assign || function() {
                    return (n = Object.assign || function(e) {
                        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                    }).apply(this, arguments);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.loadOptionsFromAttributes = t.transformAttributeValue = t.camelCaseToKebabCase = void 0, t.camelCaseToKebabCase = function(e) {
                    return e.split("").map(function(e, t) {
                        return e.toUpperCase() === e ? (0 !== t ? "-" : "") + e.toLowerCase() : e;
                    }).join("");
                };
                var o = function(e) {
                    return e || void 0;
                }, r = function(e) {
                    return "" === e || "yes" === e || "true" === e;
                }, i = function(e) {
                    var t = e ? parseInt(e, 10) : NaN;
                    return isNaN(t) ? void 0 : t;
                }, a = "%ESCAPED_COMMA%";
                t.transformAttributeValue = function(e, t) {
                    var u, s;
                    switch(t){
                        case "string":
                            return o(e);
                        case "boolean":
                            return r(e);
                        case "integer":
                            return i(e);
                        case "function":
                            return function(e) {
                                var t = e && e in window ? window[e] : void 0;
                                return "function" == typeof t ? t : void 0;
                            }(e);
                        case "array":
                            return function(e) {
                                if (e) return e.replace(/\s/g, "").replace(/\\,/g, a).split(",").filter(function(e) {
                                    return !!e;
                                }).map(function(e) {
                                    return e.replace(a, ",");
                                });
                            }(e);
                        case "record":
                            return function(e) {
                                if (e) return e.replace(/\\,/g, a).split(",").filter(function(e) {
                                    return !!e;
                                }).map(function(e) {
                                    return e.replace(a, ",");
                                }).reduce(function(e, t) {
                                    var o, r = t.match(/^([^=]+)=(.*)$/);
                                    if (r) {
                                        var i = r[1], a = r[2];
                                        return n(n({}, e), ((o = {})[i.trim()] = a, o));
                                    }
                                    return e;
                                }, {});
                            }(e);
                        case "integerOrBoolean":
                            return null !== (u = i(e)) && void 0 !== u ? u : r(e);
                        case "stringOrBoolean":
                            return null !== (s = o(e)) && void 0 !== s ? s : r(e);
                        default:
                            throw new Error("Invalid attribute transformation " + t);
                    }
                }, t.loadOptionsFromAttributes = function(e, o) {
                    return Object.keys(o).reduce(function(r, i) {
                        var a;
                        return n(n({}, r), ((a = {})[i] = t.transformAttributeValue(e.getAttribute("data-tf-" + t.camelCaseToKebabCase(i)), o[i]), a));
                    }, {});
                };
            },
            318: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.makeAutoResize = void 0;
                var o = n(563);
                t.makeAutoResize = function(e) {
                    return function() {
                        e && o.isMobile() && e.style.setProperty("height", window.innerHeight + "px", "important");
                    };
                };
            },
            563: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isFullscreen = t.isMobile = t.isBigScreen = void 0, t.isBigScreen = function() {
                    return window.screen.width >= 1024 && window.screen.height >= 768;
                }, t.isMobile = function() {
                    return /mobile|tablet|android/i.test(navigator.userAgent.toLowerCase());
                }, t.isFullscreen = function() {
                    return t.isMobile() && !t.isBigScreen();
                };
            },
            527: function(e, t, n) {
                var o = this && this.__assign || function() {
                    return (o = Object.assign || function(e) {
                        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                    }).apply(this, arguments);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.removeUndefinedKeys = void 0;
                var r = n(346);
                t.removeUndefinedKeys = function(e) {
                    return Object.entries(e).filter(function(e) {
                        var t = e[1];
                        return r.isDefined(t);
                    }).reduce(function(e, t) {
                        var n, r = t[0], i = t[1];
                        return o(o({}, e), ((n = {})[r] = i, n));
                    }, {});
                };
            },
            748: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.setAutoClose = void 0;
                var o = n(554);
                t.setAutoClose = function(e, t, n) {
                    if (t && n) {
                        var r = "number" == typeof t ? t : 0;
                        window.addEventListener("message", o.getFormSubmitHandler(e, function() {
                            return setTimeout(n, r);
                        }));
                    }
                };
            },
            533: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.setElementSize = void 0, t.setElementSize = function(e, t) {
                    var n = t.width, o = t.height;
                    return n && (e.style.width = n + "px"), o && (e.style.height = o + "px"), e;
                };
            },
            392: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.setupGaInstance = t.sendGaIdMessage = void 0, t.sendGaIdMessage = function(e, t, n) {
                    var o = {
                        embedId: e,
                        gaClientId: t
                    };
                    setTimeout(function() {
                        n && n.contentWindow && n.contentWindow.postMessage({
                            type: "ga-client-id",
                            data: o
                        }, "*");
                    }, 0);
                };
                var n = function(e) {
                    console.error(e);
                };
                t.setupGaInstance = function(e, o, r) {
                    try {
                        var i = window[window.GoogleAnalyticsObject], a = "string" == typeof r ? r : void 0, u = function(e, t) {
                            return t ? e.find(function(e) {
                                return e.get("trackingId") === t;
                            }) : e[0];
                        }(i.getAll(), a);
                        u ? t.sendGaIdMessage(o, u.get("clientId"), e) : n("Whoops! You enabled the shareGaInstance feature in your typeform embed but the tracker with ID " + a + " was not found. Make sure to include Google Analytics Javascript code before the Typeform Embed Javascript code in your page and use correct tracker ID. ");
                    } catch (e) {
                        n("Whoops! You enabled the shareGaInstance feature in your typeform embed but the Google Analytics object has not been found. Make sure to include Google Analytics Javascript code before the Typeform Embed Javascript code in your page. "), n(e);
                    }
                };
            },
            451: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.unmountElement = void 0, t.unmountElement = function(e) {
                    var t;
                    null === (t = e.parentNode) || void 0 === t || t.removeChild(e);
                };
            }
        }, t = {};
        return function n(o) {
            if (t[o]) return t[o].exports;
            var r = t[o] = {
                exports: {}
            };
            return e[o].call(r.exports, r, r.exports, n), r.exports;
        }(920);
    }();
});

});


//# sourceMappingURL=hub.2ad9f52d.js.map
